import React, { useState, useEffect } from 'react';
import axios from 'axios';

function MetadataModal({ isOpen, onClose, recording, apiUrl, secret, apiBaseUrl, onUpdated }) {
  const [meetingName, setMeetingName] = useState('');
  const [description, setDescription] = useState('');
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen && recording) {
      setMeetingName(recording.name || '');
      setDescription(recording.metadata?.description || '');
      setError('');
    }
  }, [isOpen, recording]);

  if (!isOpen || !recording) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUpdating(true);
    setError('');

    try {
      await axios.post(`${apiBaseUrl}/api/recordings/meta`, {
        apiUrl,
        secret,
        recordID: recording.recordID,
        meta: {
          name: meetingName,
          description: description
        }
      });

      onUpdated(recording.recordID, { name: meetingName, description });
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update metadata.');
      setUpdating(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: '480px' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h3 className="modal-title">Edit Recording Details</h3>
            <p style={{ fontSize: '0.8rem', color: 'var(--slate-500)', marginTop: '2px' }}>
              {recording.recordID}
            </p>
          </div>
          <button className="btn-icon" onClick={onClose} aria-label="Close modal">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && (
              <div style={{ padding: '0.75rem', background: 'var(--danger-light)', color: 'var(--danger-text)', borderRadius: 'var(--radius-md)', marginBottom: '1rem', fontSize: '0.85rem' }}>
                {error}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Meeting Name</label>
              <input
                type="text"
                className="form-control"
                value={meetingName}
                onChange={(e) => setMeetingName(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Description (Optional)</label>
              <textarea
                className="form-control"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Optional description or lecture summary..."
              />
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary btn-sm" onClick={onClose} disabled={updating}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary btn-sm" disabled={updating}>
              {updating ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default MetadataModal;
